import { render, staticRenderFns } from "./OnboardingQuestionCall.vue?vue&type=template&id=d0cc980a"
import script from "./OnboardingQuestionCall.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports